export class LoggingPanelModel {

  constructor(
    public orgId: string,
    public functionId: string,
    public FilterType: string,
    public MileageFilterType: string = "0",
    public EntityFilterType: string = "0",
    public showSearch: boolean = false,
    public filterByKeys: string[] = [],
    public claimantNames: Map<number, string> = new Map<number, string>(),
    public fallbackActionByName: string = ""
  ) {
  }
}

export class LoggingPanelFilterOption {
  constructor(
    public dropdownName: string,
    public matchText: string) {

  }
}

export class LoggingPanelData {
  constructor(
    public Date: string,
    public ActionBy: string,    
    public Log: string) {

  }
}
